import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';

// styles
import styles from './PdpSharedMakerHeadshotModule.scss';

// helpers
import get from 'lodash.get';

const viewProfile = (
    <FormattedMessage id="PdpSharedMakerHeadshotModule.viewProfile" defaultMessage="View Profile" />
);

function PdpSharedMakerHeadshotModuleComponent({ seller, renderHeadshot }) {
    const name = get(seller, 'sellerProfile.company');
    const urlLabel = get(seller, 'sellerPreferences.urlLabel');

    const liveStorefront = get(seller, 'liveStorefrontProfile') || {};
    const photos = get(liveStorefront, 'photos') || [];
    const headshot = photos.find(photo => get(photo, 'type.name') === 'DEALER_STOREFRONT_HEADSHOT');

    return (
        <div className={styles.wrapper}>
            {/* Headshot */}
            {!!(headshot && headshot.path) && (
                <div className={styles.imageWrap}>
                    {renderHeadshot({ path: headshot.path, imgClass: styles.image, alt: name })}
                </div>
            )}
            {/* Name / View Profile link */}
            <div>
                <p className={styles.name}>{name}</p>
                <a href={`/dealers/${urlLabel}/`}>{viewProfile}</a>
            </div>
        </div>
    );
}

PdpSharedMakerHeadshotModuleComponent.propTypes = {
    seller: PropTypes.object.isRequired,
    renderHeadshot: PropTypes.func.isRequired,
};

PdpSharedMakerHeadshotModuleComponent.defaultProps = {
    //eslint-disable-next-line react/display-name, react/prop-types
    renderHeadshot: ({ path, imgClass, alt }) => <img className={imgClass} src={path} alt={alt} />,
};

export const PdpSharedMakerHeadshotModule = createFragmentContainer(
    PdpSharedMakerHeadshotModuleComponent,
    {
        seller: graphql`
            fragment PdpSharedMakerHeadshotModule_seller on Seller {
                sellerProfile {
                    company
                }
                sellerPreferences {
                    urlLabel
                }
                liveStorefrontProfile {
                    photos {
                        type {
                            name
                        }
                        path
                    }
                }
            }
        `,
    }
);
